export default {
    state: {
        highlighted: 'suggest__item_state_highlighted',
        animated: 'suggest_state_animated',
    },
    hover: {
        disable: 'suggest__items_hover_disabled',
        enable: 'suggest__items_hover_enabled',
    },
    layer: {
        floating: 'suggest_layer-floating',
        overlay: 'suggest_layer-overlay',
        topmost: 'suggest_layer-topmost',
        'above-content': 'suggest_layer-above-content',
        'overlay-content': 'suggest_layer-overlay-content',
        'above-overlay-content': 'suggest_layer-above-overlay-content',
    },
    highlightSelector: 'Bloko-Suggest-Highlight',
};
